export function initRoleCards() {
    const cards = document.querySelectorAll('[data-role-info-card]');
    if (!cards.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const running = new Set();
    const animate = (element, frames, options = {}) => {
        if (!element || reduced.matches) return;
        const animation = element.animate(frames, { duration: 900, easing: 'ease-in-out', ...options });
        running.add(animation);
        animation.finished.catch(() => {}).finally(() => running.delete(animation));
    };
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target: card, isIntersecting }) => {
            if (!isIntersecting) return;
            observer.unobserve(card);
            if (reduced.matches) return;
            const rtl = getComputedStyle(card).direction === 'rtl';
            const gauge = card.querySelector('.by-role-info-cards__gauge path:last-child');
            if (gauge) {
                // Reveal the existing SVG sector around its centre, from its top end.
                const svg = gauge.ownerSVGElement;
                const ns = 'http://www.w3.org/2000/svg';
                const defs = document.createElementNS(ns, 'defs');
                const mask = document.createElementNS(ns, 'mask');
                const circle = document.createElementNS(ns, 'circle');
                mask.id = `role-gauge-${Array.from(cards).indexOf(card)}`;
                mask.setAttribute('maskUnits', 'userSpaceOnUse');
                mask.setAttribute('x', '0'); mask.setAttribute('y', '0');
                mask.setAttribute('width', '360'); mask.setAttribute('height', '360');
                circle.setAttribute('cx', '177.925'); circle.setAttribute('cy', '177.005');
                circle.setAttribute('r', '116'); circle.setAttribute('fill', 'none');
                circle.setAttribute('stroke', 'white'); circle.setAttribute('stroke-width', '60');
                circle.setAttribute('transform', 'rotate(-78 177.925 177.005)');
                const circumference = 2 * Math.PI * 116;
                circle.style.strokeDasharray = String(circumference);
                mask.append(circle); defs.append(mask); svg.prepend(defs);
                gauge.setAttribute('mask', `url(#${mask.id})`);
                animate(circle, [{ strokeDashoffset: -circumference }, { strokeDashoffset: 0 }], { duration: 1200 });
            }
            card.querySelectorAll('.by-role-info-cards__card--free-svg circle[fill="#30DF96"]').forEach((dot, i) => {
                animate(dot, [{ fill: '#F4F4F4' }, { fill: '#30DF96' }], { duration: 120, delay: i * 8, fill: 'backwards' });
            });
            animate(card.querySelector('.by-role-info-cards__card--go-image'), [{ transform: 'translateY(-110%)' }, { transform: 'translateY(0)' }]);
            animate(card.querySelector('.highlight'), [{ opacity: 0 }, { opacity: 1 }], { duration: 450, delay: 900, fill: 'backwards' });
            animate(card.querySelector('.by-role-info-cards__image--coins'), [{ transform: `translate(${rtl ? '-90%' : '90%'}, 60%)` }, { transform: 'translate(0, 0)' }]);
            animate(card.querySelector('.by-role-info-cards__image--plane'), [{ transform: `translate(${rtl ? '80%' : '-80%'}, 100%)` }, { transform: 'translate(0, 0)' }]);
            card.querySelectorAll('.by-role-info-cards__bars span b').forEach((bar, i) => {
                animate(bar, [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { delay: i * 120, fill: 'backwards', easing: 'cubic-bezier(.22,.61,.36,1)' });
            });
        });
    }, { threshold: 0.2 });
    cards.forEach((card) => observer.observe(card));
    reduced.addEventListener('change', () => { if (reduced.matches) running.forEach((animation) => animation.cancel()); });
}
